import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-multiple-assign',
  templateUrl: './tickets-multiple-assign.component.html',
  styleUrls: ['./tickets-multiple-assign.component.scss'],
  standalone: false,
})
export class TicketsMultipleAssignComponent {
  @Input() ticketsMultipleAssign;

  public ticketsListRefresh(): void {
    this.ticketsMultipleAssign.ticketsListRefresh();
  }

  public onResetCheckedTickets(): void {
    this.ticketsMultipleAssign.onResetCheckedTickets();
  }
}
